/*
  EYS floating buttons

  The chat button (Shopify Inbox) and the wishlist button (XB Wishlist) both sit bottom right and can
  land on top of each other: the chat moves up for the theme editor's preview bar, and its offset is
  an app setting. This measures the chat button and parks the wishlist button directly above it,
  in line, 12px apart, with the same shape (both are the shop pink: eys-footer.css). eys-footer.css
  reads the values it sets on <html>: --eys-wl-bottom, --eys-wl-right, --eys-float-radius.
  It also tidies XB Wishlist's wording: the "Save for later" pop-up, notifications and Wishlist page.
  Loaded on every page by sections/eys-floats.liquid (footer group).
*/
(function () {
  'use strict';

  if (window.EYS && window.EYS.floats) return;

  var html = document.documentElement;
  var GAP = 12;
  var SIZE = 50; // the chat button's full size; it shrinks to about 30px while the page scrolls
  var seenChat = false;
  var tries = 0;
  var pollTimer = null;
  var resizeTimer = null;

  var chatButton = function () {
    var host = document.querySelector('shopify-chat') || document.querySelector('inbox-online-store-chat');
    var shadow = host && host.shadowRoot;
    var btn = shadow && (shadow.querySelector('[part~="activator"]') || shadow.querySelector('.activator'));
    return btn ? { host: host, btn: btn } : null;
  };

  var place = function () {
    var wl = document.querySelector('.xb-wishlist__float-style-1');
    if (!wl) return false;

    // Hide the count bubble while the wishlist is empty.
    var count = wl.querySelector('.xb-wishlist__float-style-1-number');
    if (count) wl.classList.toggle('eys-wl-empty', (parseInt(count.textContent, 10) || 0) < 1);

    var chat = chatButton();
    if (!chat) return false;
    var b = chat.btn.getBoundingClientRect();
    // Chat window open, or the button hidden: keep the last position.
    if (!b.width || !b.height) return seenChat;
    seenChat = true;

    if (b.left + b.width / 2 < window.innerWidth / 2) {
      // Chat on the left: the wishlist button keeps the right-hand corner to itself.
      html.style.setProperty('--eys-wl-bottom', '20px');
      html.style.removeProperty('--eys-wl-right');
      return true;
    }

    // Work from the chat button's resting place: the offsets of its wrapper from the bottom-right
    // corner of the chat layer. These stay put while the button shrinks on scroll. Distances are
    // measured from the chat layer's own bottom edge, so lifting both above the product page's
    // Add to basket bar (--eys-float-lift) keeps them together.
    var wrap = chat.btn.parentElement;
    var spot = wrap ? window.getComputedStyle(wrap) : null;
    var bottom = spot ? parseFloat(spot.bottom) : NaN;
    var right = spot ? parseFloat(spot.right) : NaN;
    if (isNaN(bottom) || isNaN(right)) {
      var h = chat.host.getBoundingClientRect();
      bottom = h.bottom - b.bottom;
      right = h.right - b.right;
    }
    var size = Math.max(SIZE, Math.round(b.height));
    html.style.setProperty('--eys-wl-bottom', Math.round(bottom + size + GAP) + 'px');
    html.style.setProperty('--eys-wl-right', Math.max(0, Math.round(right)) + 'px');

    // Match the chat button's shape.
    var look = window.getComputedStyle(chat.btn);
    var radius = parseFloat(look.borderTopLeftRadius);
    if (!isNaN(radius) && b.height) html.style.setProperty('--eys-float-radius', Math.min(SIZE / 2, Math.round(radius / b.height * SIZE)) + 'px');
    return true;
  };

  // Both widgets load late and on their own schedule: keep looking for about twenty seconds.
  var poll = function () {
    clearTimeout(pollTimer);
    if (place() || tries++ > 28) {
      // No chat button on this page: the wishlist button takes the corner.
      if (!seenChat && document.querySelector('.xb-wishlist__float-style-1')) html.style.setProperty('--eys-wl-bottom', '20px');
      return;
    }
    pollTimer = setTimeout(poll, 700);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poll, { once: true });
  else poll();

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(place, 250);
  }, { passive: true });

  // The wishlist count changes when a shopper taps a heart.
  document.addEventListener('click', function () { setTimeout(place, 900); }, true);

  /* XB Wishlist: the "Save for later" pop-up shown when an item is removed from the basket, the app's
     notifications and its Wishlist page. Clearer wording, UK English and prices with their currency
     and VAT label; eys-wishlist.css does the styling. Saved items go to the "Saved for later"
     tab of the Wishlist page, not the wishlist itself, so the wording says so. Text is changed in
     place, never replaced, so the app can keep updating its own elements. */
  var SFL = 'xb-wishlist-modal-save-for-later';
  // Exact app texts (lower case) and what to show instead
  var SWAPS = {
    'save for later successfully': 'Saved for later. It’s on your Wishlist page.',
    'item has been successfully added to your wishlist': 'Added to your wishlist.',
    'item has been successfully removed from your wishlist': 'Removed from your wishlist.',
    'remove from save for later successfully': 'Removed from Saved for later.',
    'item has been temporarily added to wishlist, please': 'Added to your wishlist.',
    'login': 'Sign in',
    'to save it permanently': 'to save it to your account.',
    'wishlist page': 'Wishlist',
    'save for later': 'Saved for later',
    'add to cart': 'Add to basket',
    'apologies, no results were found. try adding some items from': 'Nothing here yet. Products you save will appear here. Browse',
    'categories': 'all products'
  };
  var swapTexts = function (root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var key = node.data.trim().toLowerCase();
      if (!key || !Object.prototype.hasOwnProperty.call(SWAPS, key)) continue;
      var next = node.data.match(/^\s*/)[0] + SWAPS[key] + node.data.match(/\s*$/)[0];
      if (node.data !== next) node.data = next;
    }
  };
  var setText = function (el, text) {
    if (!el) return;
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType === 3 && node.data.trim()) {
        if (node.data !== text) node.data = text;
        return;
      }
    }
    if (!el.children.length) el.textContent = text;
  };
  var money = function (amount) {
    var cents = Math.round(amount * 100);
    if (window.EYS && typeof window.EYS.money === 'function') return window.EYS.money(cents);
    return '£' + (cents / 100).toFixed(2);
  };
  // Prices are stored ex VAT, as the rest of the site shows them.
  var exVat = function (el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType === 3 && /\d/.test(node.data) && !/VAT/.test(node.data)) node.data = node.data.replace(/\s*$/, '') + ' ex VAT';
    }
  };
  var tidySaveForLater = function (modal) {
    var part = function (name) { return modal.querySelector('.' + SFL + name); };
    setText(part('__title'), 'Save it for later?');
    setText(modal.querySelector('.' + SFL + '__content p'), 'We’ll keep it on your Wishlist page, so it’s easy to find when you’re ready.');
    var price = part('__product-price');
    // The app shows a bare number here ("7.00")
    if (price && /^\s*\d[\d,]*(\.\d+)?\s*$/.test(price.textContent)) {
      setText(price, money(parseFloat(price.textContent.replace(/[^\d.]/g, ''))) + ' ex VAT');
    }
    setText(part('__button--cancel'), 'No thanks');
    setText(part('__button--save'), 'Save for later');
    var close = part('__close');
    if (close && !close.getAttribute('aria-label')) close.setAttribute('aria-label', 'Close');
  };
  var tidyXb = function () {
    var modal = document.querySelector('.' + SFL);
    if (modal) tidySaveForLater(modal);
    var notes = document.querySelectorAll('.xb-wishlist-notification__message');
    for (var i = 0; i < notes.length; i++) swapTexts(notes[i]);
    var page = document.querySelector('.xb-wishlist-products');
    if (page) {
      swapTexts(page);
      var prices = page.querySelectorAll('.xb-wishlist-product__price span:not([class*="compareAtPrice"])');
      for (var j = 0; j < prices.length; j++) exVat(prices[j]);
    }
  };
  if ('MutationObserver' in window && document.body) {
    // characterData too: the app updates some text in place (a button saying "Adding", say)
    new MutationObserver(tidyXb).observe(document.body, { childList: true, subtree: true, characterData: true });
    tidyXb();
  }

  window.EYS = window.EYS || {};
  window.EYS.floats = { place: place };
})();